import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Header, Titulo} from '../elementos/Header'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioUsuario from './FormularioUsuario'
import favicon from '../imagenes/logoutm.png'

const CrearUsuario = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Registro de Usuarios</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Registro de Usuarios</Titulo>
                    <BtnRegresar ruta="/usuarios"/>
            </Header>

            <FormularioUsuario />
        </>
    );
}
 
export default CrearUsuario;